import * as ACTIONS from  '../../containers/constants';

export function success(payload) {
  return { type: ACTIONS.SUCCESS, payload };
}

export function error(payload) {
  return { type: ACTIONS.ERROR, payload };
}

export function clear() {
  return { type: ACTIONS.CLEAR };
}
